import { useNavigate } from 'react-router-dom';
import { DillButton } from '../Dill';
import { SignOut } from 'phosphor-react';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { exitPreviewMode } from '../../../redux/globalSlices/previewSlice';

export const PreviewModeBanner = ({ onExit }: { onExit?: () => void }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { returnPath, previewMainBuyer } = useAppSelector((state) => state.preview);

  const handleExitPreview = () => {
    const path = returnPath || `/customers/${previewMainBuyer?.buyerId}`;
    dispatch(exitPreviewMode());
    if (onExit) {
      onExit();
    }
    navigate(path);
  };

  return (
    <div
      className="sticky top-0 left-0 right-0 bg-blue-600 text-white py-1 px-4 z-50 flex justify-between items-center"
      style={{ zIndex: 1000 }}>
      <span className="font-medium text-xs">
        Preview Mode: Viewing as Buyer{previewMainBuyer ? ` (${previewMainBuyer.name})` : ''}
      </span>
      <DillButton
        label="Exit Preview"
        variant="secondary"
        icon={<SignOut size={18} className="text-gray-600" />}
        onClick={handleExitPreview}
      />
    </div>
  );
};
